var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { Chip, Collapse, Divider, FormHelperText, Grid, IconButton, TextField, Typography } from "@mui/material";
import { GridAddIcon, GridRemoveIcon } from '@mui/x-data-grid-premium';
import { t } from "i18next";
import { debounce } from '@mui/material';
;
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getPriceWithTaxUrl, getTaxUrl } from "../../../../api/url";
import { ChevronDownIcon, ChevronUpIcon } from "../../../../assets/customIcons";
import { ArrowDownIcon, ArrowUPIcon } from "../../../../assets/images";
import { FormSearchSelect } from "../../../../builderPackage/components/dynamicFormBuilder/components/formSearchSelect";
import { InputBox, MuiButton, MuiStack } from "../../../../components";
import { MuiSelectComponent } from "../../../../components/atoms/muiSelectComponent";
import { LOCAL_STORAGE_KEYS } from "../../../../constants";
import { showLoader } from "../../../../redux/commonSlice";
import { getListAPI } from "../../../../redux/crudSlice";
import { useAppDispatch } from "../../../../store/hooks";
import { getLocalStorageItem } from "../../../../utils/storageHelper";
import { REG } from "../../../../utils/validationHelper";
import { getServiceTypeList, UnitOfMeasurementList } from "../../../jobCardDetails/services/apiCalls";
var regex = REG.validateDecimalAndNonNumeric;
export var CommonPartLabourDetails = function (props) {
    var _selectedPriceDetails, _drawerItem$jobType, _drawerItem$jobType2, _drawerItem$jobType3, _selectedPriceDetails2, _selectedPriceDetails3;
    var jobItemDetails = props.jobItemDetails, partsLabourList = props.partsLabourList, setPartsLabourList = props.setPartsLabourList, index = props.index, isAccordianRequired = props.isAccordianRequired, SystemName = props.SystemName, accordianIndex = props.accordianIndex, setAccordianIndex = props.setAccordianIndex, setShuffleTotal = props.setShuffleTotal, isDisabled = props.isDisabled;
    var tempPartsLabourList = partsLabourList;
    var _a = useSelector(function (state) { return state.crud; }), ModuleDetailsGetById = _a.ModuleDetailsGetById, documentDetailsGetById = _a.documentDetailsGetById;
    var _b = useState(jobItemDetails.SelectedPriceDetails), selectedPriceDetails = _b[0], setSelectedPriceDetails = _b[1];
    var documentDetails = ModuleDetailsGetById !== null && ModuleDetailsGetById !== void 0 && ModuleDetailsGetById.data ? ModuleDetailsGetById : documentDetailsGetById;
    var _c = useState(false), openTaxes = _c[0], setOpenTaxes = _c[1];
    var _d = useState(false), openSummary = _d[0], setOpenSummary = _d[1];
    var dispatch = useAppDispatch();
    var storedSelectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var totalTax = (selectedPriceDetails === null || selectedPriceDetails === void 0 || (_selectedPriceDetails = selectedPriceDetails.Taxes) === null || _selectedPriceDetails === void 0 ? void 0 : _selectedPriceDetails.reduce(function (accaccumulator, currentObj) { return Number(accaccumulator) + Number(currentObj.TaxComponentAmount); }, 0).toFixed(2)) || 0..toFixed(2);
    var updatePartsLabourList = function (index, updatedItem) {
        tempPartsLabourList[index] = updatedItem;
        setPartsLabourList(tempPartsLabourList);
    };
    var _e = useState(jobItemDetails), drawerItem = _e[0], setDrawerItem = _e[1];
    useEffect(function () {
        if (jobItemDetails) {
            setDrawerItem(jobItemDetails);
            if (jobItemDetails.SelectedPriceDetails) {
                setSelectedPriceDetails(jobItemDetails.SelectedPriceDetails);
            }
            else {
                setSelectedPriceDetails(jobItemDetails.Price[0]);
            }
        }
    }, [jobItemDetails]);
    var handleShuffleTotal = function () {
        setShuffleTotal(function (prevValue) { return !prevValue; });
    };
    var handleServiceType = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var _event$target, _event$target2, _event$target$value, _event$target3, _event$target$value2, _event$target4, PricesBasedOnServiceType, updatedItem;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(event !== null && event !== void 0 && (_event$target = event.target) !== null && _event$target !== void 0 && _event$target.value)) return [3 /*break*/, 2];
                    return [4 /*yield*/, getPriceDetailsWithTax(event === null || event === void 0 || (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.value, drawerItem.UnitOfMeasurementId)];
                case 1:
                    PricesBasedOnServiceType = _a.sent();
                    setDrawerItem(_objectSpread(_objectSpread({}, drawerItem), {}, {
                        ServiceTypeId: (_event$target$value = event === null || event === void 0 || (_event$target3 = event.target) === null || _event$target3 === void 0 ? void 0 : _event$target3.value) !== null && _event$target$value !== void 0 ? _event$target$value : "",
                        Price: PricesBasedOnServiceType
                    }));
                    updatedItem = _objectSpread(_objectSpread({}, drawerItem), {}, {
                        ServiceTypeId: (_event$target$value2 = event === null || event === void 0 || (_event$target4 = event.target) === null || _event$target4 === void 0 ? void 0 : _event$target4.value) !== null && _event$target$value2 !== void 0 ? _event$target$value2 : "",
                        Price: PricesBasedOnServiceType
                    });
                    if (PricesBasedOnServiceType.length > 0) {
                        setSelectedPriceDetails(PricesBasedOnServiceType[0]);
                        updatedItem = _objectSpread(_objectSpread({}, updatedItem), {}, {
                            SelectedPriceDetails: PricesBasedOnServiceType[0]
                        });
                    }
                    updatePartsLabourList(index, updatedItem);
                    handleShuffleTotal();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleChangeUOM = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var _event$target5, _event$target6, _event$target$value3, _event$target7, _event$target$value4, _event$target8, PricesBasedOnServiceType, updatedItem, updatedItem_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(event !== null && event !== void 0 && (_event$target5 = event.target) !== null && _event$target5 !== void 0 && _event$target5.value)) return [3 /*break*/, 2];
                    return [4 /*yield*/, getPriceDetailsWithTax(drawerItem.ServiceTypeId, event === null || event === void 0 || (_event$target6 = event.target) === null || _event$target6 === void 0 ? void 0 : _event$target6.value)];
                case 1:
                    PricesBasedOnServiceType = _a.sent();
                    setDrawerItem(_objectSpread(_objectSpread({}, drawerItem), {}, {
                        UnitOfMeasurementId: (_event$target$value3 = event === null || event === void 0 || (_event$target7 = event.target) === null || _event$target7 === void 0 ? void 0 : _event$target7.value) !== null && _event$target$value3 !== void 0 ? _event$target$value3 : "",
                        Price: PricesBasedOnServiceType
                    }));
                    updatedItem = _objectSpread(_objectSpread({}, drawerItem), {}, {
                        UnitOfMeasurementId: (_event$target$value4 = event === null || event === void 0 || (_event$target8 = event.target) === null || _event$target8 === void 0 ? void 0 : _event$target8.value) !== null && _event$target$value4 !== void 0 ? _event$target$value4 : "",
                        Price: PricesBasedOnServiceType
                    });
                    updatePartsLabourList(index, updatedItem);
                    if (PricesBasedOnServiceType.length > 0) {
                        setSelectedPriceDetails(PricesBasedOnServiceType[0]);
                        updatedItem_1 = _objectSpread(_objectSpread({}, drawerItem), {}, {
                            SelectedPriceDetails: PricesBasedOnServiceType[0]
                        });
                        updatePartsLabourList(index, updatedItem_1);
                    }
                    handleShuffleTotal();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleChangePrice = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var selectedMRP, selectedPrice, updatedItem;
        return __generator(this, function (_a) {
            selectedMRP = event.target.value;
            selectedPrice = drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.Price.find(function (item) { return item.MRP === selectedMRP; });
            if (selectedPrice) {
                setSelectedPriceDetails(selectedPrice);
                updatedItem = _objectSpread(_objectSpread({}, drawerItem), {}, {
                    SelectedPriceDetails: selectedPrice
                });
                updatePartsLabourList(index, updatedItem);
                handleShuffleTotal();
            }
            return [2 /*return*/];
        });
    }); };
    var handleInputRateChange = function (event, item) {
        var value = event.target.value;
        value = value.replace(/^0+(?!\.)/, '');
        if (regex.test(value) || value == '') {
            var _item$SelectedPriceDe, _item$SelectedPriceDe6, _item$SelectedPriceDe8;
            if ((item === null || item === void 0 || (_item$SelectedPriceDe = item.SelectedPriceDetails) === null || _item$SelectedPriceDe === void 0 ? void 0 : _item$SelectedPriceDe.EditableRange) == 0) {
                var _item$SelectedPriceDe2, _item$SelectedPriceDe3, _item$SelectedPriceDe4, _item$SelectedPriceDe5;
                if ((item === null || item === void 0 || (_item$SelectedPriceDe2 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe2 === void 0 ? void 0 : _item$SelectedPriceDe2.MinPrice) == null && (item === null || item === void 0 || (_item$SelectedPriceDe3 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe3 === void 0 ? void 0 : _item$SelectedPriceDe3.MaxPrice) == null) {
                    var _event$target$value5, _event$target9, _event$target$value6, _event$target10;
                    setSelectedPriceDetails(_objectSpread(_objectSpread({}, selectedPriceDetails), {}, {
                        Rate: (_event$target$value5 = event === null || event === void 0 || (_event$target9 = event.target) === null || _event$target9 === void 0 ? void 0 : _event$target9.value) !== null && _event$target$value5 !== void 0 ? _event$target$value5 : ""
                    }));
                    var updatedItem = _objectSpread(_objectSpread({}, drawerItem), {}, {
                        SelectedPriceDetails: _objectSpread(_objectSpread({}, selectedPriceDetails), {}, {
                            Rate: (_event$target$value6 = event === null || event === void 0 || (_event$target10 = event.target) === null || _event$target10 === void 0 ? void 0 : _event$target10.value) !== null && _event$target$value6 !== void 0 ? _event$target$value6 : ""
                        })
                    });
                    updatePartsLabourList(index, updatedItem);
                    handleShuffleTotal();
                    return;
                }
                if (value <= (item === null || item === void 0 || (_item$SelectedPriceDe4 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe4 === void 0 ? void 0 : _item$SelectedPriceDe4.MaxPrice) && value >= (item === null || item === void 0 || (_item$SelectedPriceDe5 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe5 === void 0 ? void 0 : _item$SelectedPriceDe5.MinPrice) || value == "") {
                    var _value, _value2;
                    setSelectedPriceDetails(_objectSpread(_objectSpread({}, selectedPriceDetails), {}, {
                        Rate: (_value = value) !== null && _value !== void 0 ? _value : ""
                    }));
                    var updatedItem = _objectSpread(_objectSpread({}, drawerItem), {}, {
                        SelectedPriceDetails: _objectSpread(_objectSpread({}, selectedPriceDetails), {}, {
                            Rate: (_value2 = value) !== null && _value2 !== void 0 ? _value2 : ""
                        })
                    });
                    updatePartsLabourList(index, updatedItem);
                    handleShuffleTotal();
                }
            }
            else if ((item === null || item === void 0 || (_item$SelectedPriceDe6 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe6 === void 0 ? void 0 : _item$SelectedPriceDe6.EditableRange) == 1) {
                var _item$SelectedPriceDe7;
                if (value <= (item === null || item === void 0 || (_item$SelectedPriceDe7 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe7 === void 0 ? void 0 : _item$SelectedPriceDe7.MaxPrice) || value == "") {
                    var _value3, _value4;
                    setSelectedPriceDetails(_objectSpread(_objectSpread({}, selectedPriceDetails), {}, {
                        Rate: (_value3 = value) !== null && _value3 !== void 0 ? _value3 : ""
                    }));
                    var updatedItem = _objectSpread(_objectSpread({}, drawerItem), {}, {
                        SelectedPriceDetails: _objectSpread(_objectSpread({}, selectedPriceDetails), {}, {
                            Rate: (_value4 = value) !== null && _value4 !== void 0 ? _value4 : ""
                        })
                    });
                    updatePartsLabourList(index, updatedItem);
                    handleShuffleTotal();
                }
            }
            else if ((item === null || item === void 0 || (_item$SelectedPriceDe8 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe8 === void 0 ? void 0 : _item$SelectedPriceDe8.EditableRange) == 2) {
                var _item$SelectedPriceDe9;
                if (value >= (item === null || item === void 0 || (_item$SelectedPriceDe9 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe9 === void 0 ? void 0 : _item$SelectedPriceDe9.MinPrice) || value == "") {
                    var _value5, _value6;
                    setSelectedPriceDetails(_objectSpread(_objectSpread({}, selectedPriceDetails), {}, {
                        Rate: (_value5 = value) !== null && _value5 !== void 0 ? _value5 : ""
                    }));
                    var updatedItem = _objectSpread(_objectSpread({}, drawerItem), {}, {
                        SelectedPriceDetails: _objectSpread(_objectSpread({}, selectedPriceDetails), {}, {
                            Rate: (_value6 = value) !== null && _value6 !== void 0 ? _value6 : ""
                        })
                    });
                    updatePartsLabourList(index, updatedItem);
                    handleShuffleTotal();
                }
            }
        }
    };
    var getTaxDebounced = useCallback(debounce(function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var TaxesBasedOnQuantity, _TaxesBasedOnQuantity, _TaxesBasedOnQuantity2, _TaxesBasedOnQuantity3, _TaxesBasedOnQuantity4, _TaxesBasedOnQuantity5, _TaxesBasedOnQuantity6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getTax(Number(Number(value).toFixed(2)), selectedPriceDetails.Rate)];
                case 1:
                    TaxesBasedOnQuantity = _a.sent();
                    if (TaxesBasedOnQuantity.success && TaxesBasedOnQuantity !== null && TaxesBasedOnQuantity !== void 0 && TaxesBasedOnQuantity.data) {
                        setSelectedPriceDetails(_objectSpread(_objectSpread({}, selectedPriceDetails), {}, {
                            Amount: TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity === void 0 ? void 0 : _TaxesBasedOnQuantity.Amount,
                            MRP: TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity2 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity2 === void 0 ? void 0 : _TaxesBasedOnQuantity2.MRP,
                            Rate: TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity3 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity3 === void 0 ? void 0 : _TaxesBasedOnQuantity3.Rate,
                            TaxableAmount: TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity4 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity4 === void 0 ? void 0 : _TaxesBasedOnQuantity4.TaxableAmount,
                            Taxes: TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity5 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity5 === void 0 ? void 0 : _TaxesBasedOnQuantity5.Taxes,
                            BaseAmount: TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity6 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity6 === void 0 ? void 0 : _TaxesBasedOnQuantity6.BaseAmount
                        }));
                    }
                    return [2 /*return*/];
            }
        });
    }); }, 500), [selectedPriceDetails]);
    var handleQuantityChange = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var value, updatedItem, DecimalPrecision, validationRules;
        return __generator(this, function (_a) {
            value = event.target.value;
            // Allow only numeric input (including decimal)
            if (!/^\d*\.?\d*$/.test(value))
                return [2 /*return*/];
            updatedItem = _objectSpread(_objectSpread({}, drawerItem), {}, {
                error: false,
                errorMessage: ""
            });
            if (!(+value > 0) && value !== "") {
                updatedItem.error = true;
                updatedItem.errorMessage = "Quantity should be greater than 0";
            }
            else {
                DecimalPrecision = drawerItem.DecimalPrecision;
                validationRules = {
                    0: REG.validateInteger,
                    1: REG.validateDecimalUptoOneDigit,
                    2: REG.validateDecimalAndNonNumeric
                };
                if (DecimalPrecision !== undefined && validationRules[DecimalPrecision]) {
                    if (!validationRules[DecimalPrecision].test(value) && value !== "") {
                        updatedItem.error = true;
                        updatedItem.errorMessage = "Up to ".concat(DecimalPrecision, " decimal precision is allowed");
                        if (DecimalPrecision === 0) {
                            updatedItem.errorMessage = "Enter Qty in multiple of 1";
                        }
                    }
                    else {
                        updatedItem.Quantity = value;
                    }
                }
            }
            if (!updatedItem.error) {
                getTaxDebounced(value);
            }
            setDrawerItem(updatedItem);
            updatePartsLabourList(index, updatedItem);
            handleShuffleTotal();
            return [2 /*return*/];
        });
    }); };
    var handleQuantityIncrement = function () { return __awaiter(void 0, void 0, void 0, function () {
        var setSucess, TaxesBasedOnQuantity, _TaxesBasedOnQuantity7, _TaxesBasedOnQuantity8, _TaxesBasedOnQuantity9, _TaxesBasedOnQuantity10, _TaxesBasedOnQuantity11, _TaxesBasedOnQuantity12, _TaxesBasedOnQuantity13, _TaxesBasedOnQuantity14, _TaxesBasedOnQuantity15, _TaxesBasedOnQuantity16, _TaxesBasedOnQuantity17, _TaxesBasedOnQuantity18, updatedDrawerItem;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSucess = true;
                    return [4 /*yield*/, getTax(Number((Number(drawerItem.Quantity) + 1).toFixed(2)), selectedPriceDetails.Rate)];
                case 1:
                    TaxesBasedOnQuantity = _a.sent();
                    if (TaxesBasedOnQuantity.success && TaxesBasedOnQuantity !== null && TaxesBasedOnQuantity !== void 0 && TaxesBasedOnQuantity.data) {
                        setSelectedPriceDetails(_objectSpread(_objectSpread({}, selectedPriceDetails), {}, {
                            Amount: TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity7 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity7 === void 0 ? void 0 : _TaxesBasedOnQuantity7.Amount,
                            MRP: TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity8 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity8 === void 0 ? void 0 : _TaxesBasedOnQuantity8.MRP,
                            Rate: TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity9 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity9 === void 0 ? void 0 : _TaxesBasedOnQuantity9.Rate,
                            TaxableAmount: TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity10 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity10 === void 0 ? void 0 : _TaxesBasedOnQuantity10.TaxableAmount,
                            Taxes: TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity11 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity11 === void 0 ? void 0 : _TaxesBasedOnQuantity11.Taxes,
                            Quantity: (Number(drawerItem.Quantity) + 1).toFixed(2),
                            BaseAmount: TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity12 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity12 === void 0 ? void 0 : _TaxesBasedOnQuantity12.BaseAmount
                        }));
                    }
                    else {
                        setSucess = false;
                    }
                    if (setSucess) {
                        updatedDrawerItem = _objectSpread(_objectSpread({}, drawerItem), {}, {
                            Quantity: (Number(drawerItem.Quantity) + 1).toFixed(2),
                            SelectedPriceDetails: _objectSpread(_objectSpread({}, drawerItem.SelectedPriceDetails), {}, {
                                Amount: (TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity13 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity13 === void 0 ? void 0 : _TaxesBasedOnQuantity13.Amount) || 0,
                                MRP: (TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity14 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity14 === void 0 ? void 0 : _TaxesBasedOnQuantity14.MRP) || 0,
                                Rate: (TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity15 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity15 === void 0 ? void 0 : _TaxesBasedOnQuantity15.Rate) || 0,
                                TaxableAmount: (TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity16 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity16 === void 0 ? void 0 : _TaxesBasedOnQuantity16.TaxableAmount) || 0,
                                Taxes: (TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity17 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity17 === void 0 ? void 0 : _TaxesBasedOnQuantity17.Taxes) || [],
                                Quantity: (Number(drawerItem.Quantity) + 1).toFixed(2),
                                BaseAmount: (TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity18 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity18 === void 0 ? void 0 : _TaxesBasedOnQuantity18.BaseAmount) || 0
                            })
                        });
                        setDrawerItem(updatedDrawerItem);
                        updatePartsLabourList(index, updatedDrawerItem);
                        handleShuffleTotal();
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleQuantityDecrement = function () { return __awaiter(void 0, void 0, void 0, function () {
        var TaxesBasedOnQuantity, setSucess, _TaxesBasedOnQuantity19, _TaxesBasedOnQuantity20, _TaxesBasedOnQuantity21, _TaxesBasedOnQuantity22, _TaxesBasedOnQuantity23, _TaxesBasedOnQuantity24, _TaxesBasedOnQuantity25, _TaxesBasedOnQuantity26, _TaxesBasedOnQuantity27, _TaxesBasedOnQuantity28, _TaxesBasedOnQuantity29, _TaxesBasedOnQuantity30, updatedDrawerItem;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(Number(drawerItem.Quantity) > 1)) return [3 /*break*/, 2];
                    return [4 /*yield*/, getTax(Number((Number(drawerItem.Quantity) - 1).toFixed(2)), selectedPriceDetails.Rate)];
                case 1:
                    TaxesBasedOnQuantity = _a.sent();
                    setSucess = true;
                    if (TaxesBasedOnQuantity.success && TaxesBasedOnQuantity !== null && TaxesBasedOnQuantity !== void 0 && TaxesBasedOnQuantity.data) {
                        setSelectedPriceDetails(_objectSpread(_objectSpread({}, selectedPriceDetails), {}, {
                            Amount: TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity19 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity19 === void 0 ? void 0 : _TaxesBasedOnQuantity19.Amount,
                            MRP: TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity20 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity20 === void 0 ? void 0 : _TaxesBasedOnQuantity20.MRP,
                            Rate: TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity21 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity21 === void 0 ? void 0 : _TaxesBasedOnQuantity21.Rate,
                            TaxableAmount: TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity22 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity22 === void 0 ? void 0 : _TaxesBasedOnQuantity22.TaxableAmount,
                            Taxes: TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity23 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity23 === void 0 ? void 0 : _TaxesBasedOnQuantity23.Taxes,
                            Quantity: (Number(drawerItem.Quantity) - 1).toFixed(2),
                            BaseAmount: TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity24 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity24 === void 0 ? void 0 : _TaxesBasedOnQuantity24.BaseAmount
                        }));
                    }
                    else {
                        setSucess = false;
                    }
                    if (setSucess) {
                        updatedDrawerItem = _objectSpread(_objectSpread({}, drawerItem), {}, {
                            Quantity: (Number(drawerItem.Quantity) - 1).toFixed(2),
                            SelectedPriceDetails: _objectSpread(_objectSpread({}, drawerItem.SelectedPriceDetails), {}, {
                                Amount: (TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity25 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity25 === void 0 ? void 0 : _TaxesBasedOnQuantity25.Amount) || 0,
                                MRP: (TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity26 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity26 === void 0 ? void 0 : _TaxesBasedOnQuantity26.MRP) || 0,
                                Rate: (TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity27 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity27 === void 0 ? void 0 : _TaxesBasedOnQuantity27.Rate) || 0,
                                TaxableAmount: (TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity28 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity28 === void 0 ? void 0 : _TaxesBasedOnQuantity28.TaxableAmount) || 0,
                                Taxes: (TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity29 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity29 === void 0 ? void 0 : _TaxesBasedOnQuantity29.Taxes) || [],
                                Quantity: (Number(drawerItem.Quantity) - 1).toFixed(2),
                                BaseAmount: (TaxesBasedOnQuantity === null || TaxesBasedOnQuantity === void 0 || (_TaxesBasedOnQuantity30 = TaxesBasedOnQuantity.data) === null || _TaxesBasedOnQuantity30 === void 0 ? void 0 : _TaxesBasedOnQuantity30.BaseAmount) || 0
                            })
                        });
                        setDrawerItem(updatedDrawerItem);
                        updatePartsLabourList(index, updatedDrawerItem);
                        handleShuffleTotal();
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var getPriceDetailsWithTax = function (ServiceTypeId, UOMId) { return __awaiter(void 0, void 0, void 0, function () {
        var _documentDetails$data, _documentDetails$data2, _documentDetails$data3, _documentDetails$data4, _Response$payload, _Response$payload2, _Response$payload3, requestBody, Response, _Response$payload4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        "SystemName": drawerItem.jobType === "Part" ? "Parts" : "Service",
                        "ItemId": drawerItem.ChildId,
                        "OrganizationId": storedSelectedBranch === null || storedSelectedBranch === void 0 ? void 0 : storedSelectedBranch.OrganizationId,
                        "VinNo": documentDetails === null || documentDetails === void 0 || (_documentDetails$data = documentDetails.data) === null || _documentDetails$data === void 0 ? void 0 : _documentDetails$data.VinNo,
                        "PreJobCardDocumentId": documentDetails === null || documentDetails === void 0 || (_documentDetails$data2 = documentDetails.data) === null || _documentDetails$data2 === void 0 ? void 0 : _documentDetails$data2.id,
                        "Quantity": drawerItem.Quantity,
                        "Entity": SystemName,
                        "UnitOfMeasurementId": UOMId,
                        "ServiceTypeId": ServiceTypeId,
                        OrganizationStateCode: documentDetails === null || documentDetails === void 0 || (_documentDetails$data3 = documentDetails.data) === null || _documentDetails$data3 === void 0 ? void 0 : _documentDetails$data3.OrganizationStateCode,
                        CustomerStateCode: documentDetails === null || documentDetails === void 0 || (_documentDetails$data4 = documentDetails.data) === null || _documentDetails$data4 === void 0 ? void 0 : _documentDetails$data4.CustomerStateCode,
                        HSNSACCode: selectedPriceDetails.HSNSACCode,
                        CDMSHSNSACCode: selectedPriceDetails.CDMSHSNSACCode
                    };
                    // if (drawerItem.jobType === "Part") {
                    //     requestBody.HSNCode = drawerItem.HSNCode
                    // } else {
                    //     requestBody.SACCode = drawerItem.SACCode
                    // }
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    // if (drawerItem.jobType === "Part") {
                    //     requestBody.HSNCode = drawerItem.HSNCode
                    // } else {
                    //     requestBody.SACCode = drawerItem.SACCode
                    // }
                    _a.sent();
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: getPriceWithTaxUrl,
                            request: requestBody
                        }))];
                case 2:
                    Response = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    console.log("Response", Response);
                    if (Response !== null && Response !== void 0 && (_Response$payload = Response.payload) !== null && _Response$payload !== void 0 && (_Response$payload = _Response$payload.value) !== null && _Response$payload !== void 0 && _Response$payload.success && Response !== null && Response !== void 0 && (_Response$payload2 = Response.payload) !== null && _Response$payload2 !== void 0 && (_Response$payload2 = _Response$payload2.value) !== null && _Response$payload2 !== void 0 && _Response$payload2.data && (Response === null || Response === void 0 || (_Response$payload3 = Response.payload) === null || _Response$payload3 === void 0 || (_Response$payload3 = _Response$payload3.value) === null || _Response$payload3 === void 0 || (_Response$payload3 = _Response$payload3.data) === null || _Response$payload3 === void 0 ? void 0 : _Response$payload3.length) > 0) {
                        return [2 /*return*/, Response === null || Response === void 0 || (_Response$payload4 = Response.payload) === null || _Response$payload4 === void 0 || (_Response$payload4 = _Response$payload4.value) === null || _Response$payload4 === void 0 ? void 0 : _Response$payload4.data];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getTax = function (Qty, Rate) { return __awaiter(void 0, void 0, void 0, function () {
        var _documentDetails$data5, _documentDetails$data6, _documentDetails$data7, _Response$payload5, _Response$payload6, requestBody, Response, _Response$payload7, data, success;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        MRP: selectedPriceDetails === null || selectedPriceDetails === void 0 ? void 0 : selectedPriceDetails.MRP,
                        Quantity: Qty,
                        "Rate": Rate,
                        DocumentDate: documentDetails === null || documentDetails === void 0 || (_documentDetails$data5 = documentDetails.data) === null || _documentDetails$data5 === void 0 ? void 0 : _documentDetails$data5.CreatedOn,
                        "Entity": SystemName,
                        "ServiceTypeId": drawerItem.ServiceTypeId,
                        "UnitOfMeasurementId": drawerItem.UnitOfMeasurementId,
                        "PriceMethod": (selectedPriceDetails === null || selectedPriceDetails === void 0 ? void 0 : selectedPriceDetails.PriceGroupCategoryKey) || "MRP",
                        OrganizationStateCode: documentDetails === null || documentDetails === void 0 || (_documentDetails$data6 = documentDetails.data) === null || _documentDetails$data6 === void 0 ? void 0 : _documentDetails$data6.OrganizationStateCode,
                        CustomerStateCode: documentDetails === null || documentDetails === void 0 || (_documentDetails$data7 = documentDetails.data) === null || _documentDetails$data7 === void 0 ? void 0 : _documentDetails$data7.CustomerStateCode,
                        HSNSACCode: selectedPriceDetails.HSNSACCode,
                        CDMSHSNSACCode: selectedPriceDetails.CDMSHSNSACCode
                    };
                    // if (drawerItem.jobType === "Part") {
                    //     requestBody.HSNCode = drawerItem.HSNCode
                    // } else {
                    //     requestBody.SACCode = drawerItem.SACCode
                    // }
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    // if (drawerItem.jobType === "Part") {
                    //     requestBody.HSNCode = drawerItem.HSNCode
                    // } else {
                    //     requestBody.SACCode = drawerItem.SACCode
                    // }
                    _a.sent();
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: getTaxUrl,
                            request: requestBody
                        }))];
                case 2:
                    Response = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    if (Response !== null && Response !== void 0 && (_Response$payload5 = Response.payload) !== null && _Response$payload5 !== void 0 && (_Response$payload5 = _Response$payload5.value) !== null && _Response$payload5 !== void 0 && _Response$payload5.success && Response !== null && Response !== void 0 && (_Response$payload6 = Response.payload) !== null && _Response$payload6 !== void 0 && (_Response$payload6 = _Response$payload6.value) !== null && _Response$payload6 !== void 0 && _Response$payload6.data) {
                        data = Response === null || Response === void 0 || (_Response$payload7 = Response.payload) === null || _Response$payload7 === void 0 || (_Response$payload7 = _Response$payload7.value) === null || _Response$payload7 === void 0 ? void 0 : _Response$payload7.data;
                        success = true;
                        return [2 /*return*/, {
                                data: data,
                                success: success
                            }];
                    }
                    else {
                        return [2 /*return*/, {
                                data: null,
                                success: false
                            }];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleTaxesBasedOnRateChange = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var TaxesBasedOnRate, setSucess, _TaxesBasedOnRate$dat, _TaxesBasedOnRate$dat2, _TaxesBasedOnRate$dat3, _TaxesBasedOnRate$dat4, _TaxesBasedOnRate$dat5, _TaxesBasedOnRate$dat6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getTax(Number(drawerItem.Quantity), Number(event.target.value))];
                case 1:
                    TaxesBasedOnRate = _a.sent();
                    setSucess = true;
                    if (TaxesBasedOnRate.success && TaxesBasedOnRate !== null && TaxesBasedOnRate !== void 0 && TaxesBasedOnRate.data) {
                        setSelectedPriceDetails(_objectSpread(_objectSpread({}, selectedPriceDetails), {}, {
                            Amount: TaxesBasedOnRate === null || TaxesBasedOnRate === void 0 || (_TaxesBasedOnRate$dat = TaxesBasedOnRate.data) === null || _TaxesBasedOnRate$dat === void 0 ? void 0 : _TaxesBasedOnRate$dat.Amount,
                            MRP: TaxesBasedOnRate === null || TaxesBasedOnRate === void 0 || (_TaxesBasedOnRate$dat2 = TaxesBasedOnRate.data) === null || _TaxesBasedOnRate$dat2 === void 0 ? void 0 : _TaxesBasedOnRate$dat2.MRP,
                            Rate: TaxesBasedOnRate === null || TaxesBasedOnRate === void 0 || (_TaxesBasedOnRate$dat3 = TaxesBasedOnRate.data) === null || _TaxesBasedOnRate$dat3 === void 0 ? void 0 : _TaxesBasedOnRate$dat3.Rate,
                            TaxableAmount: TaxesBasedOnRate === null || TaxesBasedOnRate === void 0 || (_TaxesBasedOnRate$dat4 = TaxesBasedOnRate.data) === null || _TaxesBasedOnRate$dat4 === void 0 ? void 0 : _TaxesBasedOnRate$dat4.TaxableAmount,
                            Taxes: TaxesBasedOnRate === null || TaxesBasedOnRate === void 0 || (_TaxesBasedOnRate$dat5 = TaxesBasedOnRate.data) === null || _TaxesBasedOnRate$dat5 === void 0 ? void 0 : _TaxesBasedOnRate$dat5.Taxes,
                            BaseAmount: TaxesBasedOnRate === null || TaxesBasedOnRate === void 0 || (_TaxesBasedOnRate$dat6 = TaxesBasedOnRate.data) === null || _TaxesBasedOnRate$dat6 === void 0 ? void 0 : _TaxesBasedOnRate$dat6.BaseAmount
                        }));
                    }
                    else {
                        setSucess = false;
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleShowAccordian = function (index) {
        {
            setAccordianIndex && setAccordianIndex(function (prevIndex) { return prevIndex === index ? null : index; });
        }
        setOpenSummary(false);
        setOpenTaxes(false);
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 1,
        sx: {
            borderRadius: '8px',
            boxShadow: '0px 0px 16px #00000014',
            p: 1
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center',
        width: '100%',
        spacing: 1
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        alignItems: 'center',
        justifyContent: 'space-between'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'flex-start',
        alignItems: "flex-start"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            textTransform: 'capitalize',
            fontWeight: "medium",
            fontSize: 'lg',
            color: 'text.primary'
        }
    }, (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.PartName) || (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.LabourName) || "-")))), /*#__PURE__*/ React.createElement(Chip, {
        label: drawerItem === null || drawerItem === void 0 || (_drawerItem$jobType = drawerItem.jobType) === null || _drawerItem$jobType === void 0 ? void 0 : _drawerItem$jobType.substring(0, 1),
        id: drawerItem === null || drawerItem === void 0 || (_drawerItem$jobType2 = drawerItem.jobType) === null || _drawerItem$jobType2 === void 0 ? void 0 : _drawerItem$jobType2.substring(0, 1),
        color: "secondary",
        variant: "filled",
        shape: "circular",
        sx: {
            color: "secondary.900"
        }
    }), isAccordianRequired && /*#__PURE__*/ React.createElement(IconButton, {
        onClick: function () { return handleShowAccordian(index); }
    }, /*#__PURE__*/ React.createElement("img", {
        src: accordianIndex === index ? ArrowUPIcon : ArrowDownIcon,
        alt: "toggle",
        width: "16px",
        height: "16px"
    }))), /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: (drawerItem === null || drawerItem === void 0 || (_drawerItem$jobType3 = drawerItem.jobType) === null || _drawerItem$jobType3 === void 0 ? void 0 : _drawerItem$jobType3.substring(0, 1)) == "P" ? "part-code" : 'labour-code',
        sx: {
            fontSize: 'sm',
            fontWeight: 'mormal',
            color: 'text.secondary'
        }
    }, "#".concat((drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.PartCode) || (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.LabourCode) || drawerItem.SkuCode) || "-")))), (accordianIndex === index || !isAccordianRequired) && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            pt: '8px !important'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            // '&::after': {
            //     content: '"*"',
            //     color: 'red',
            //     marginLeft: '2px',
            // },
            fontWeight: "medium",
            fontSize: 'sm',
            color: 'text.secondary'
        },
        paddingY: 1
    }, t("Service type")), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(FormSearchSelect, {
        tabIndex: 1,
        id: "serviceType",
        name: "serviceType",
        noOptionsText: "No records found",
        fullWidth: true,
        value: (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.ServiceTypeId) || "",
        displayExpr: "DisplayName",
        valueExpr: "id",
        getListData: getServiceTypeList,
        apiKey: 'serviceTypeList',
        disabled: true,
        onChange: handleServiceType
    })))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            // '&::after': {
            //     content: '"*"',
            //     color: 'red',
            //     marginLeft: '2px',
            // }
            fontWeight: "medium",
            fontSize: 'sm',
            color: 'text.secondary'
        },
        paddingY: 1
    }, "Rate(\u20B9)"), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(InputBox, {
        tabIndex: 1,
        placeholder: 'Enter rate',
        fullWidth: true,
        size: "small",
        value: selectedPriceDetails === null || selectedPriceDetails === void 0 ? void 0 : selectedPriceDetails.Rate,
        name: "rate",
        onChange: function (event) { return handleInputRateChange(event, drawerItem); },
        onBlur: function (e) { return handleTaxesBasedOnRateChange(e); },
        disabled: !(selectedPriceDetails !== null && selectedPriceDetails !== void 0 && selectedPriceDetails.IsRateEditable) || isDisabled
        // error={usageReadingError.error}
        // helperText={t(usageReadingError.errorMessage)}
        ,
        inputProps: {
            inputMode: 'numeric',
            pattern: '[0-9]*',
            maxLength: 6
        },
        sx: {
            "& .MuiInputBase-root.Mui-disabled": {
                backgroundColor: "secondary.50",
                borderRadius: '8px'
            }
        },
        id: "rate"
    })))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            // '&::after': {
            //     content: '"*"',
            //     color: 'red',
            //     marginLeft: '2px',
            // }
            fontWeight: "medium",
            fontSize: 'sm',
            color: 'text.secondary'
        },
        paddingY: 1
    }, drawerItem.jobType === "Part" ? "Qty" : "Unit"), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiStack, {
        height: '36px',
        width: '36px',
        justifyContent: 'center',
        sx: {
            border: "1px solid",
            borderColor: 'secondary.200',
            borderRadius: 0,
            borderTopLeftRadius: '8px',
            borderBottomLeftRadius: '8px'
        }
    }, /*#__PURE__*/ React.createElement(IconButton, {
        onClick: handleQuantityDecrement,
        size: "small",
        disabled: isDisabled
    }, /*#__PURE__*/ React.createElement(GridRemoveIcon, null))), /*#__PURE__*/ React.createElement(TextField, {
        value: drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.Quantity,
        variant: "outlined",
        size: "small",
        inputProps: {
            style: {
                textAlign: 'center',
                height: '25px',
                padding: 0
            }
        },
        sx: {
            borderTop: "1px solid",
            borderBottom: "1px solid",
            borderColor: 'secondary.200',
            '& fieldset': {
                border: 'none'
            },
            '& .MuiOutlinedInput-root': {
                borderRadius: 0
            },
            '& .MuiInputBase-root': {
                height: '100%'
            }
        },
        onChange: function (event) {
            handleQuantityChange(event);
        },
        error: drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.error,
        disabled: isDisabled,
        type: "number"
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        height: '36px',
        width: '36px',
        justifyContent: 'center',
        sx: {
            border: "1px solid",
            borderColor: 'secondary.200',
            borderRadius: 0,
            borderTopRightRadius: '8px',
            borderBottomRightRadius: '8px'
        }
    }, /*#__PURE__*/ React.createElement(IconButton, {
        onClick: function () { return handleQuantityIncrement(); },
        size: "small",
        disabled: isDisabled
    }, /*#__PURE__*/ React.createElement(GridAddIcon, null))))), (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.errorMessage) && /*#__PURE__*/ React.createElement(FormHelperText, {
        sx: {
            color: 'red'
        }
    }, drawerItem.errorMessage)), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            // '&::after': {
            //     content: '"*"',
            //     color: 'red',
            //     marginLeft: '2px',
            // },
            fontWeight: "medium",
            fontSize: 'sm',
            color: 'text.secondary'
        },
        paddingY: 1
    }, "UOM"), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(FormSearchSelect, {
        id: "select-uom",
        name: "UOM",
        noOptionsText: "No records found",
        fullWidth: true,
        value: (drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.UnitOfMeasurementId) || "",
        displayExpr: "Name",
        valueExpr: "id",
        getListData: UnitOfMeasurementList,
        apiKey: 'UnitOfMeasurementList',
        disabled: true,
        tabIndex: 3,
        onChange: handleChangeUOM
    })))), drawerItem.jobType === "Part" && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            // '&::after': {
            //     content: '"*"',
            //     color: 'red',
            //     marginLeft: '2px',
            // },
            fontWeight: "medium",
            fontSize: 'sm',
            color: 'text.secondary'
        },
        paddingY: 1
    }, "M.R.P.(\u20B9)"), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        tabIndex: 2,
        caption: t('MRP_SELECT_PLACEHOLDER'),
        margin: 0,
        fullWidth: true,
        name: "mrp",
        value: selectedPriceDetails === null || selectedPriceDetails === void 0 ? void 0 : selectedPriceDetails.MRP,
        displayExpr: "MRP",
        valueExpr: "MRP",
        onChange: handleChangePrice,
        options: (Array.isArray(drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.Price) ? drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.Price : [drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.Price]) || [],
        id: "select-mrp",
        disabled: (selectedPriceDetails === null || selectedPriceDetails === void 0 ? void 0 : selectedPriceDetails.PriceGroupCategoryKey) !== "MRP" || isDisabled
    })))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            width: '100%'
        }
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'space-between',
        width: '100%'
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontWeight: "strong",
            fontSize: 'base',
            color: 'text.primary'
        }
    }, "Amount"), /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontWeight: "strong",
            fontSize: 'base',
            color: 'text.primary'
        }
    }, "\u20B9 ".concat(((selectedPriceDetails === null || selectedPriceDetails === void 0 ? void 0 : selectedPriceDetails.Amount) || 0).toFixed(2))))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            pt: '0px !important'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        justifyContent: 'end'
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        onClick: function () {
            if (openSummary) {
                setOpenTaxes(false);
            }
            setOpenSummary(!openSummary);
        },
        variant: "text",
        endIcon: openSummary ? /*#__PURE__*/ React.createElement(ChevronUpIcon, null) : /*#__PURE__*/ React.createElement(ChevronDownIcon, null),
        name: "See summary",
        size: "small",
        sx: {
            backgroundColor: 'transparent',
            pr: 0,
            fontWeight: "medium",
            fontSize: 'sm'
        },
        id: "add-again"
    }))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            pt: '0px !important'
        }
    }, /*#__PURE__*/ React.createElement(Collapse, {
        in: openSummary,
        sx: {
            borderRadius: '8px',
            boxShadow: '0px 0px 16px 0px #00000014'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        padding: '12px'
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 1,
        sx: {
            mt: 1
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontWeight: "medium",
            fontSize: 'sm',
            color: 'text.secondary'
        }
    }, "Base amount")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        textAlign: "right"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontWeight: "medium",
            fontSize: 'base',
            color: 'text.primary'
        }
    }, "\u20B9 ".concat(((selectedPriceDetails === null || selectedPriceDetails === void 0 ? void 0 : selectedPriceDetails.BaseAmount) || 0).toFixed(2)))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontWeight: "medium",
            fontSize: 'sm',
            color: 'text.secondary'
        }
    }, "Taxable amount")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        textAlign: "right"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontWeight: "medium",
            fontSize: 'base',
            color: 'text.primary'
        }
    }, "\u20B9 ".concat(((selectedPriceDetails === null || selectedPriceDetails === void 0 ? void 0 : selectedPriceDetails.TaxableAmount) || 0).toFixed(2)))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        sx: {
            pt: '0px !important'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontWeight: "medium",
            cursor: "pointer",
            fontSize: 'sm',
            color: 'text.secondary'
        },
        onClick: function () { return setOpenTaxes(!openTaxes); }
    }, "Taxes"), /*#__PURE__*/ React.createElement(IconButton, {
        size: "small",
        onClick: function () { return setOpenTaxes(!openTaxes); }
    }, openTaxes ? /*#__PURE__*/ React.createElement(ExpandLess, {
        sx: {
            fontSize: 25
        }
    }) : /*#__PURE__*/ React.createElement(ExpandMore, {
        sx: {
            fontSize: 25
        }
    })))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 6,
        textAlign: "right"
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontWeight: "medium",
            fontSize: 'base',
            color: 'text.primary'
        }
    }, "\u20B9 ", totalTax))), openTaxes && /*#__PURE__*/ React.createElement(Collapse, {
        in: openTaxes,
        sx: {
            mt: 1,
            bgcolor: "secondary.50",
            p: 2,
            borderRadius: 2
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 1
    }, selectedPriceDetails && (selectedPriceDetails === null || selectedPriceDetails === void 0 || (_selectedPriceDetails2 = selectedPriceDetails.Taxes) === null || _selectedPriceDetails2 === void 0 ? void 0 : _selectedPriceDetails2.length) > 0 ? selectedPriceDetails === null || selectedPriceDetails === void 0 || (_selectedPriceDetails3 = selectedPriceDetails.Taxes) === null || _selectedPriceDetails3 === void 0 ? void 0 : _selectedPriceDetails3.map(function (tax, index) {
        return /*#__PURE__*/ React.createElement(React.Fragment, {
            key: index
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 6
        }, /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                fontWeight: "medium",
                fontSize: 'sm',
                color: 'text.tertiary'
            }
        }, tax === null || tax === void 0 ? void 0 : tax.TaxComponentName, " :")), /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 6,
            sx: {
                display: 'flex',
                justifyContent: 'end'
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                fontWeight: "medium",
                fontSize: 'base',
                color: 'text.secondary'
            }
        }, tax === null || tax === void 0 ? void 0 : tax.TaxComponentPercentage, "%"), /*#__PURE__*/ React.createElement(Divider, {
            sx: {
                mx: 1.5,
                my: 0.5,
                bgcolor: 'secondary.50'
            },
            orientation: "vertical",
            flexItem: true
        }), /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                fontWeight: "medium",
                fontSize: 'base',
                color: 'text.primary'
            }
        }, "\u20B9 ", parseFloat(tax === null || tax === void 0 ? void 0 : tax.TaxComponentAmount).toFixed(2))));
    }) : /*#__PURE__*/ React.createElement(MuiStack, {
        padding: 1
    }, /*#__PURE__*/ React.createElement(Typography, null, t("No data found")))))))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            width: '100%'
        }
    }))), !(accordianIndex === index || !isAccordianRequired) && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            paddingY: 0.5
        }
    }, /*#__PURE__*/ React.createElement(Divider, {
        style: {
            width: '100%'
        }
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        height: '50px',
        justifyContent: 'space-between',
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '40%'
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontWeight: "strong",
            fontSize: 'base',
            color: 'text.primary'
        }
    }, "\u20B9 ".concat((selectedPriceDetails === null || selectedPriceDetails === void 0 ? void 0 : selectedPriceDetails.Amount) || 0))), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '40%'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        height: '36px',
        width: '36px',
        justifyContent: 'center',
        sx: {
            border: "1px solid",
            borderColor: 'secondary.200',
            borderRadius: 0,
            borderTopLeftRadius: '4px',
            borderBottomLeftRadius: '4px'
        }
    }, /*#__PURE__*/ React.createElement(IconButton, {
        onClick: handleQuantityDecrement,
        size: "small",
        disabled: isDisabled
    }, /*#__PURE__*/ React.createElement(GridRemoveIcon, null))), /*#__PURE__*/ React.createElement(TextField, {
        value: drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.Quantity,
        variant: "outlined",
        size: "small",
        inputProps: {
            style: {
                textAlign: 'center',
                height: '25px',
                padding: 0
            }
        },
        sx: {
            borderTop: "1px solid",
            borderBottom: "1px solid",
            borderColor: 'secondary.200',
            '& fieldset': {
                border: 'none'
            },
            '& .MuiOutlinedInput-root': {
                borderRadius: 0
            },
            '& .MuiInputBase-root': {
                height: '100%'
            }
        },
        onChange: function (event) {
            handleQuantityChange(event);
        },
        error: drawerItem === null || drawerItem === void 0 ? void 0 : drawerItem.error,
        disabled: isDisabled,
        type: "number"
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        height: '36px',
        width: '36px',
        justifyContent: 'center',
        sx: {
            border: "1px solid",
            borderColor: 'secondary.200',
            borderRadius: 0,
            borderTopRightRadius: '4px',
            borderBottomRightRadius: '4px'
        }
    }, /*#__PURE__*/ React.createElement(IconButton, {
        onClick: function () { return handleQuantityIncrement(); },
        size: "small",
        disabled: isDisabled
    }, /*#__PURE__*/ React.createElement(GridAddIcon, null)))))))));
};
